/**
 * Sentinel option for the dropdown revamp (ticket 18848).
 *
 * Optional single-select dropdowns under the revamp render a "--" item at the
 * top of the list. Picking it clears the field. We model this as a synthetic
 * option carrying a structural `__isSentinel` marker — detection is by marker,
 * never by value equality, so backend option values that happen to match
 * `SENTINEL_VALUE` can never be mistaken for the clear action.
 */

export const SENTINEL_VALUE = "__SELECT_NONE__"

export type SentinelOption = {
  label: string
  value: typeof SENTINEL_VALUE
  __isSentinel: true
}

export const SENTINEL_OPTION: SentinelOption = {
  label: "--",
  value: SENTINEL_VALUE,
  __isSentinel: true,
}

export function isSentinelOption(option: unknown): option is SentinelOption {
  return (
    !!option &&
    typeof option === "object" &&
    "__isSentinel" in option &&
    (option as { __isSentinel?: unknown }).__isSentinel === true
  )
}
